import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { installAuthFetch } from './auth/installAuthFetch';
import App from './App';
import './index.css';

// CRITICAL: must run BEFORE the first React render so the very first
// fetch (useAuth → /api/auth/me) carries the Bearer token.
installAuthFetch();

// Cache-bust marker — bump for any manual `wrangler pages deploy`.
// CI deploys don't need this (new commit = new hashed asset filenames).
export const BUILD_ID = '2026-05-15-001';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
